
import Easing from '../../utils/easing';

export default class HomeHero {
	constructor() {

		this.el = {
			section: document.querySelector('.hero-home'),
			scrollBug: document.querySelector('.hero-home__scroll-bug'),
			fades: document.querySelectorAll('.hero-home [data-fade-in]')
		};

		if (!this.el.section) {
			return;
		}

		this._addListeners();
	}

	_addListeners() {
		this._onScrollBugClick = this._onScrollBugClick.bind(this);
		this.el.scrollBug.addEventListener('click', this._onScrollBugClick);
	}

	_onScrollBugClick(e) {
		e.preventDefault();
		let elBottom = this.el.section.getBoundingClientRect().bottom;
		this.scrollTo(elBottom, 1000, 'easeInOutQuint');
	}

	scrollTo(destination, duration = 200, selectedEase = 'linear', callback) {
		const start = window.pageYOffset;
		const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

		const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
		const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
		const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
		const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

		if ('requestAnimationFrame' in window === false) {
			window.scroll(0, destinationOffsetToScroll);
			if (callback) {
				callback();
			}
			return;
		}

		function scroll() {

			const now = 'now' in window.performance ? performance.now() : new Date().getTime();
			const time = Math.min(1, ((now - startTime) / duration));
			const timeFunction = Easing[selectedEase](time);
			window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

			if (window.pageYOffset === destinationOffsetToScroll) {
				if (callback) {
					callback();
				}
				return;
			}

			requestAnimationFrame(scroll);
		}

		scroll();
	}
}
